import React, { useEffect, useState } from "react";
import { Grid, Typography, Box, Paper, Divider, Button } from "@material-ui/core";
import Swal from "sweetalert2";
import Api from "../../providers/Api/Api";
import { withRouter } from "react-router-dom";
import { v4 as uuidv4 } from "uuid"; // Biblioteca para gerar UUIDs

const ResumoFicha = (props) => {
  const { ficha, match, setShowBackdrop, history } = props;
  const { nomeEmpresa, chaveIdentificacao } = match.params;
  const [userAgente, setUserAgente] = useState('');

  const [loading, setLoading] = useState(false);

  const convertFileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result?.split(",")[1] || "");
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  };

  useEffect(()=>{
    setUserAgente((prevAgente)=>{
      obterNomeNavegador()
    })
  },[])
  const obterNomeNavegador = () =>{
    var usuarioAgente = navigator.userAgent;
    if (usuarioAgente.indexOf("Chrome") > -1) {
        return "Google Chrome";
    } else if (usuarioAgente.indexOf("Safari") > -1) {
        return "Safari";
    } else if (usuarioAgente.indexOf("Firefox") > -1) {
        return "Mozilla Firefox";
    } else if (usuarioAgente.indexOf("Edge") > -1) {
        return "Microsoft Edge";
    } else if (usuarioAgente.indexOf("MSIE") > -1 || usuarioAgente.indexOf("Trident") > -1) {
        return "Internet Explorer";
    } else {
        return "Desconhecido";
    }
}



  const sendUploadFicha = async () => {
    try {

      setLoading(true);
      
      setShowBackdrop(true);

      const filesBase64 = await Promise.all(
        ficha.files.map(async (item) => ({
          fileName: item.file.name,
          fileData: await convertFileToBase64(item.file),
          fileType: item.file.type,
        }))
      );

      const formData = { ...ficha,userAgente : userAgente,ramoAtividade : ficha.ramoAtividade,  codigoFicha:uuidv4() , chaveSolicitacao : chaveIdentificacao, files: filesBase64 };

      const response = await Api.post(
        "ClientesController/uploadFichaCliente",
        formData,
        { headers: { "Content-Type": "application/json" } }
      );

      const success = response.status === 200 && response.data.status === "OK";

      Swal.fire({
        title: nomeEmpresa.toUpperCase(),
        text: success ? "Sua ficha foi enviada com sucesso!" : "Não foi possível enviar sua ficha!",
        icon: success ? "success" : "warning",
        showCancelButton: false,
        showConfirmButton: false,
        timer: 2000,
      });

      if (success) {
        setTimeout(() => history.push(`/conclusao-fichacadastro/${nomeEmpresa}`), 2000);
      }
    } catch (error) {
      Swal.fire({
        title: nomeEmpresa.toUpperCase(),
        text: "Ocorreu um erro ao enviar sua ficha!",
        icon: "error",
        timer: 2000,
      });
    } finally {
      setLoading(false);
      setShowBackdrop(false);
    }
  };

  return (
    <Box style={{ padding: "5%", paddingTop: "0px" }}>
      <Paper
        style={{
          padding: "30px",
          borderRadius: "8px",
          backgroundColor: "#f9f9f9",
          boxShadow: "0 5px 15px rgba(0, 0, 0, 0.1)",
          transform: "translateY(4px)",
        }}
      >
        <Typography variant="h5" align="center" style={{ fontWeight: "bold", color: "#003366" }}>
          FICHA DE CADASTRO
        </Typography>

        <Divider style={{ marginBottom: "20px" }} />

        <Grid container spacing={4}>
          <Grid item xs={12} sm={6} md={1}>
            <Typography variant="caption">FICHA PESSOA</Typography>
            <Typography variant="subtitle1" style={{ fontWeight: "bold" }}>
              {ficha.tipoEmpresa === "J" ? "JURÍDICA" : "FÍSICA"}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6} md={2}>
            <Typography variant="caption">CNPJ/CPF</Typography>
            <Typography variant="subtitle1" style={{ fontWeight: "bold" }}>{ficha.cpfcnpj}</Typography>
          </Grid>
          <Grid item xs={12} sm={6} md={2}>
            <Typography variant="caption">Inscrição Estadual/RG</Typography>
            <Typography variant="subtitle1" style={{ fontWeight: "bold" }}>{ficha.rginsc}</Typography>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Typography variant="caption">Razão Social</Typography>
            <Typography variant="subtitle1" style={{ fontWeight: "bold" }}>{ficha.razaoSocial}</Typography>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="caption">Nome Fantasia</Typography>
            <Typography variant="subtitle1" style={{ fontWeight: "bold" }}>{ficha.nomeFantasia}</Typography>
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="caption">Ramo de Atividade</Typography>
            <Typography variant="subtitle1" style={{ fontWeight: "bold" }}>{ficha.ramoAtividade}</Typography>
          </Grid>

          <Grid item xs={12} sm={6} md={1}>
            <Typography variant="caption">CEP</Typography>
            <Typography variant="subtitle1" style={{ fontWeight: "bold" }}>{ficha.cep}</Typography>
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <Typography variant="caption">Endereço</Typography>
            <Typography variant="subtitle1" style={{ fontWeight: "bold" }}>{ficha.logradouro}</Typography>
          </Grid>

          <Grid item xs={12} sm={6} md={1}>
            <Typography variant="caption">Nº</Typography>
            <Typography variant="subtitle1" style={{ fontWeight: "bold" }}>{ficha.numero}</Typography>
          </Grid>

          <Grid item xs={12} sm={6} md={2}>
            <Typography variant="caption">Complemento</Typography>
            <Typography variant="subtitle1" style={{ fontWeight: "bold" }}>{ficha.complemento}</Typography>
          </Grid>

          <Grid item xs={12} sm={6} md={2}>
            <Typography variant="caption">Bairro</Typography>
            <Typography variant="subtitle1" style={{ fontWeight: "bold" }}>{ficha.bairro}</Typography>
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <Typography variant="caption">Cidade</Typography>
            <Typography variant="subtitle1" style={{ fontWeight: "bold" }}>{ficha.cidade}</Typography>
          </Grid>

          <Grid item xs={12} sm={6} md={1}>
            <Typography variant="caption">Estado</Typography>
            <Typography variant="subtitle1" style={{ fontWeight: "bold" }}>{ficha.estado}</Typography>
          </Grid>

          <Grid item xs={12} sm={6} md={2}>
            <Typography variant="caption">Telefone</Typography>
            <Typography variant="subtitle1" style={{ fontWeight: "bold" }}>{ficha.telefone}</Typography>
          </Grid>

          <Grid item xs={12} sm={6} md={2}>
            <Typography variant="caption">Celular</Typography>
            <Typography variant="subtitle1" style={{ fontWeight: "bold" }}>{ficha.celular}</Typography>
          </Grid>
          
        </Grid>
       

          
        

        
        <Grid container justifyContent="center" style={{ marginTop: "20px", padding : '10%', paddingTop : '25px', paddingBottom :'25px'}}>
          
            <Button
              variant="contained"
              color="primary"
              size="large"
              disabled={loading}
              fullWidth

              style={{
                backgroundColor: "#003366",
                color: "#fff",
                borderRadius: "8px",
                padding: "10px 20px",
                fontSize: "16px",
              }}
              onClick={() =>
                Swal.fire({
                  title: nomeEmpresa.toUpperCase(),
                  text: "Deseja enviar sua ficha de cadastro agora?",
                  icon: "question",
                  showCancelButton: true,
                  confirmButtonText: "SIM",
                  cancelButtonText: "Não",
                  confirmButtonColor: "#3085d6",
                  cancelButtonColor: "#d33",
                }).then((result) => {
                  if (result.isConfirmed) sendUploadFicha();
                })
              }
            >
              {loading ? "Enviando..." : "Enviar Ficha"}
            </Button>
       
        </Grid>
      </Paper>
    </Box>
  );
};

export default withRouter(ResumoFicha);
